import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { GradeAssignEmployeeComponent } from 'src/app/grade';
import { AuthGuardService } from '../../_services/common/authguard.service';
import { CanDeactivateGuard } from 'src/app/_guards/canDeactivate.guard';
import { SetupGradeWizardComponent } from 'src/app/grade/setup-grade-wizard/setup-grade-wizard.component';

const routes: Routes = [
  { path: 'grade', component: SetupGradeWizardComponent, canActivate: [AuthGuardService] },
  { path: 'gradeassignemployee', component: GradeAssignEmployeeComponent, canActivate: [AuthGuardService], canDeactivate : [CanDeactivateGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GradeRoutingModule { }
